import {
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Tooltip,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import numeral from "numeral";
import React, { useState } from "react";
import UpdateField from "./Popover/UpdateField";

const OrcamentoResumo = (props) => {
	const { astecChamadoId } = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const [popOverOpen, setPopOverOpen] = useState(null);
	const [valorDescontoAlterando, setValorDescontoAlterando] = useState(null);
	const [valorEntradaAlterando, setValorEntradaAlterando] = useState(null);
	const [valorFreteAlterando, setValorFreteAlterando] = useState(null);
	const [valorComDescontoAlterando, setValorComDescontoAlterando] =
		useState(null);

	const atualizaPorporcentagemDeDesconto = () => {
		let value =
			valorDescontoAlterando === "" ? 0 : parseFloat(valorDescontoAlterando);
		value = value >= 100 ? 99 : value;
		props.AtualizaDadosOrcamento({ porcentagemDeDesconto: value });
		handleClose();
	};

	const atualizaPorValorComDesconto = () => {
		let value =
			valorComDescontoAlterando === ""
				? 0
				: parseFloat(valorComDescontoAlterando);
		value =
			value > props.orcamentoResumo.totalSemDesconto
				? props.orcamentoResumo.totalSemDesconto
				: value;
		value = value < 0 ? 0 : value;
		props.AtualizaDadosOrcamento({ valorComDesconto: value });
		handleClose();
	};

	const atualizaPorEntrada = () => {
		const value =
			valorEntradaAlterando === "" ? 0 : parseFloat(valorEntradaAlterando);
		props.AtualizaDadosOrcamento({ entrada: value });
		handleClose();
	};

	const atualizaPorFrete = () => {
		const value =
			valorFreteAlterando === "" ? 0 : parseFloat(valorFreteAlterando);
		props.AtualizaDadosOrcamento({ frete: value });
		handleClose();
	};

	const handleClick = (event, id) => {
		setAnchorEl(event.currentTarget);
		setPopOverOpen(id);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setPopOverOpen(null);
		setValorDescontoAlterando("");
		setValorComDescontoAlterando(null);
	};

	return (
		<React.Fragment>
			{props.orcamentoResumo && (
				<div>
					<UpdateField
						elementId={"alterarTotalDesconto"}
						label={"Valor final"}
						popOverOpen={popOverOpen}
						anchorEl={anchorEl}
						handleClose={handleClose}
						valorAlterado={valorComDescontoAlterando}
						setValorAlterando={setValorComDescontoAlterando}
						atualizaPor={atualizaPorValorComDesconto}
					/>

					<UpdateField
						elementId={"alterarPorcentagemDesconto"}
						label={"Porcentagem de desconto"}
						popOverOpen={popOverOpen}
						anchorEl={anchorEl}
						handleClose={handleClose}
						valorAlterado={valorDescontoAlterando}
						setValorAlterando={setValorDescontoAlterando}
						atualizaPor={atualizaPorporcentagemDeDesconto}
					/>

					<UpdateField
						elementId={"alterarEntrada"}
						label={"Entrada"}
						popOverOpen={popOverOpen}
						anchorEl={anchorEl}
						handleClose={handleClose}
						valorAlterado={valorEntradaAlterando}
						setValorAlterando={setValorEntradaAlterando}
						atualizaPor={atualizaPorEntrada}
					/>

					<UpdateField
						elementId={"alterarFrete"}
						label={"Frete"}
						popOverOpen={popOverOpen}
						anchorEl={anchorEl}
						handleClose={handleClose}
						valorAlterado={valorFreteAlterando}
						setValorAlterando={setValorFreteAlterando}
						atualizaPor={atualizaPorFrete}
					/>

					<List dense>
						<ListItem>
							<ListItemText
								primary={numeral(props.orcamentoResumo.totalSemDesconto).format(
									"$ 0,0.00"
								)}
								secondary={"Sem desconto"}
							/>
						</ListItem>
						<Divider />
						<ListItem>
							<ListItemText
								primary={numeral(props.orcamentoResumo.totalComDesconto).format(
									"$ 0,0.00"
								)}
								secondary={"Com desconto"}
							/>
							<ListItemSecondaryAction>
								<Tooltip title="Alterar total com desconto">
									<IconButton
										edge="end"
										aria-label="delete"
										onClick={(e) => {
											handleClick(e, "alterarTotalDesconto");
										}}
									>
										<Edit color="primary" />
									</IconButton>
								</Tooltip>
							</ListItemSecondaryAction>
						</ListItem>
						<Divider />
						<ListItem
							style={{
								backgroundColor:
									astecChamadoId != null &&
									props.orcamentoResumo.porcentagemDeDesconto > 35
										? "#ff9797"
										: "#fff",
							}}
						>
							<ListItemText
								primary={
									numeral(props.orcamentoResumo.porcentagemDeDesconto).format(
										"0,0.00"
									) + "%"
								}
								secondary={"Porcentagem de desconto"}
							/>
							<ListItemSecondaryAction>
								<IconButton
									edge="end"
									aria-label="delete"
									onClick={(e) => {
										handleClick(e, "alterarPorcentagemDesconto");
									}}
								>
									<Edit color="primary" />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
						<Divider />
						<ListItem>
							<ListItemText
								primary={numeral(props.orcamentoResumo.entrada).format(
									"$ 0,0.00"
								)}
								secondary={"Entrada"}
							/>
							<ListItemSecondaryAction>
								<IconButton
									edge="end"
									aria-label="delete"
									onClick={(e) => {
										handleClick(e, "alterarEntrada");
									}}
								>
									<Edit color="primary" />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
						<Divider />
						<ListItem
							className={
								props.orcamentoResumo.totalParcelas < 0 ? "bg-error" : ""
							}
						>
							<ListItemText
								primary={numeral(props.orcamentoResumo.totalParcelas).format(
									"$ 0,0.00"
								)}
								secondary={"A ser parcelado"}
							/>
						</ListItem>

						<React.Fragment>
							<Divider />
							<ListItem>
								<ListItemText
									primary={numeral(props.orcamentoResumo.frete).format(
										"$ 0,0.00"
									)}
									secondary={"Frete"}
								/>
								<ListItemSecondaryAction>
									<IconButton
										edge="end"
										aria-label="delete"
										onClick={(e) => {
											handleClick(e, "alterarFrete");
										}}
									>
										<Edit color="primary" />
									</IconButton>
								</ListItemSecondaryAction>
							</ListItem>
						</React.Fragment>
					</List>
				</div>
			)}
		</React.Fragment>
	);
};

export default OrcamentoResumo;
